import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import { useDispatch } from "react-redux";
import { updateUserData } from "../../../store/actions/new/userUpdateAction";

const PasswordUpdate = () => {
    const dispatch = useDispatch()
    const [errorMessage, setErrorMessage] = useState('');
    const [showCurPassword, setShowCurPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const [formData, setFormData] = useState({
        U_Password: '',
        passwordConfirm: '',
        passwordCur: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        // Validate passwords
        if (formData.U_Password !== formData.passwordConfirm) {
            setErrorMessage("New password and confirm password do not match.");
            return;
        }
        const response = await dispatch(updateUserData({ "columns": formData }));
        if (response) {
            setFormData({
                U_Password: '',
                passwordConfirm: '',
                passwordCur: '',
            });
        }


    };

    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Password Update</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Update profile</h3>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="settings-list-wrapper">
                            <div className="single-settings">
                                <h5 className="setting-title">Password Change</h5>
                                <div className="setting-content">
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <label>Current password</label>
                                            <input
                                                type={showCurPassword ? "text" : "password"}
                                                className="sett-form-input"
                                                name="passwordCur"
                                                value={formData.passwordCur}
                                                onChange={handleChange}
                                                placeholder=""
                                            />
                                            <span className="pass-show-hide" onClick={() => setShowCurPassword(!showCurPassword)}>
                                                {showCurPassword ? <i className="ri-eye-line"></i> : <i className="ri-eye-off-line"></i>}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <label>New password</label>
                                            <input
                                                type={showNewPassword ? "text" : "password"}
                                                className="sett-form-input"
                                                name="U_Password"
                                                value={formData.U_Password}
                                                onChange={handleChange}
                                                placeholder=""
                                            />
                                            <span className="pass-show-hide" onClick={() => setShowNewPassword(!showNewPassword)}>
                                                {showNewPassword ? <i className="ri-eye-line"></i> : <i className="ri-eye-off-line"></i>}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <label>Confirm password</label>
                                            <input
                                                type={showNewPassword ? "text" : "password"}
                                                className="sett-form-input"
                                                name="passwordConfirm"
                                                value={formData.passwordConfirm}
                                                onChange={handleChange}
                                                placeholder=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="button-wrapper form-error-wrapper">
                                {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                                <button type="submit" className="btn submit-btn bg-primary">Update</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default PasswordUpdate;